module.exports = __webpack_public_path__ + "static/img/小鹏 P7+.2122a506.png";